import { openDB } from 'idb'
import type { DBSchema } from 'idb'
import type { UserCustomWallpaper } from './index.vue'

interface WallpaperDBSchema extends DBSchema {
  customWallpapers: {
    key: string
    value: UserCustomWallpaper
  }
}

export const wallpaperDB = openDB<WallpaperDBSchema>('themeDB', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('customWallpapers')) {
      db.createObjectStore('customWallpapers', {
        keyPath: 'id',
      })
    }
  },
})

/**
 * 保存壁纸
 * @param wallpaper 用户自定义壁纸
 */
export async function saveWallpaper(wallpaper: UserCustomWallpaper) {
  const db = await wallpaperDB

  await db.put('customWallpapers', wallpaper)
}

/**
 * 读取单个壁纸
 * @param id 壁纸id
 * @returns 壁纸详情
 */
export async function getWallpaper(id: string) {
  const db = await wallpaperDB

  return db.get('customWallpapers', id)
}

/**
 * 读取所有壁纸
 * @returns 所有壁纸详情
 */
export async function getWallpapers() {
  const db = await wallpaperDB

  return await db.getAll('customWallpapers')
}

/**
 * @param id 壁纸id
 * 删除单个壁纸
 */
export async function removeWallpaper(id: string) {
  const db = await wallpaperDB

  await db.delete('customWallpapers', id)
}

/**
 * 清空壁纸
 */
export async function clearWallpapers() {
  const db = await wallpaperDB

  await db.clear('customWallpapers')
}
